
import React, { useEffect ,useState } from "react";
import { useLocation } from "react-router-dom";
import { Helmet } from "react-helmet";
import PageBanner from "../components/PageBanner";
import { Col, Row } from "antd";
import { FaTimes } from "react-icons/fa";



const Programming = () => {
  const { pathname } = useLocation();
  useEffect(() => {
    window.scrollTo(0, 0);
  }, [pathname]);
  const [toggle, setToggle] = useState();
  const [toggle1, setToggle1] = useState();

  const handletoggle = () => {
    setToggle(!toggle);
  };
  const handletoggle1 = () => {
    setToggle1(!toggle1);
  };

  const cancletoggle = () => {
    setToggle(false);
    setToggle1(false);
  };

  const bannerData = {
    image: "/images/services/programming-banner.jpg",
    heading: "Programming & Data Processing",
    para: "    In the fast-paced world of business and market research, the ability to collect, analyze, and derive actionable insights from data is paramount. At Poll Sphere, we understand the significance of data in shaping your strategic decisions.",
  };
  return (
    <div className="page-content">
      <Helmet>
        <title>Programming & Data Processing - Precision and Speed | Poll Sphere</title>
        <meta
          name="description"
          content="Poll Sphere's Programming & Data Processing services transform raw data into meaningful insights. Our advanced techniques ensure accurate, timely results, supporting your decision-making with robust, reliable information. Experience the difference of expert data handling, from survey programming to in-depth analysis."
        />
      </Helmet>
      <PageBanner {...bannerData} />
 

      <section className="py-50">
        <div className="container">
          <Row align="middle" className="content-main-wrapper">
            <Col md={12}>
              <div className="img-wrapper">
                <img src="images/services/approach.jpg" alt="" />
              </div>
            </Col>
            <Col md={12}>
              <div className="content-wrapper px-50">
                <h2> Our Approach</h2>
                <p>
                At the heart of every successful market research and online survey effort lies a robust data infrastructure. Our Programming & Data Processing services are designed to assist you in building and maintaining this infrastructure, ensuring that you have access to accurate, timely, and relevant data at all times.
                </p>
              </div>
            </Col>
          </Row>
        </div>
      </section>

      <section>
        <div className="container-wrapper how-works ">
          <div className="img-wrapper">
            <img src="images/services/how-we-do.jpg" alt="" />
          </div>
          <div className="text-wrapper">
            <div className="container">
              <Row align="middle">
                <Col md={12}>
                  <div className="content-wrapper">
                    <h2> 
                    How we do it</h2>
                    <p>
                      {" "}
                      <strong>  Data Collection : </strong>
                    

                      We provide you with the tools and expertise needed to collect data efficiently. Whether it's through online surveys, web scraping, or other data acquisition methods, we ensure that your data sources are reliable and diverse, enabling you to gather valuable insights.
</p>
                    <div
                      className={
                        toggle
                          ? "hide-content-wrapper show"
                          : "hide-content-wrapper "
                      }
                    >
                      <div className="container ">
                        <div className="hide-text">
                          <span onClick={cancletoggle} className="cancle-btn">
                            <FaTimes />{" "}
                          </span>

                          <h2> How we do it</h2>
                    <p>
                      {" "}
                      <strong>  Data Collection : </strong>
                    

                      We provide you with the tools and expertise needed to collect data efficiently. Whether it's through online surveys, web scraping, or other data acquisition methods, we ensure that your data sources are reliable and diverse, enabling you to gather valuable insights.
</p>
                          <p>
                            {" "}
                            <strong>Data Cleaning : </strong>
                            

Raw data is often messy and incomplete. Our team of data experts specializes in cleaning and transforming data, removing inconsistencies, duplicates, and errors. This process ensures that your datasets are pristine and ready for analysis.
                          </p>
                          <p>
                            {" "}
                            <strong> Data Processing : </strong>
                            

                            Our programming and data processing capabilities extend to data manipulation, transformation, and enrichment. We structure your data in a way that makes it conducive to analysis, ensuring that you can uncover hidden trends and patterns.
                          </p>
                          <p>
                            {" "}
                            <strong>Data Analysis :</strong>
                            

                            Once your data is processed, our experts can perform in-depth statistical analysis, regression modeling, and data visualization. We use state-of-the-art tools and techniques to extract meaningful insights that drive informed decision-making.
                          </p>
                          <p>
                          
                            <strong>Reporting and Visualization : </strong>
                            

We believe that data is most valuable when it can be easily understood. Our services include creating interactive dashboards and comprehensive reports that convey the insights derived from your data effectively.
                          </p>
                          <p>
                          <strong>Data Security : </strong>
                          

We understand the importance of data security and confidentiality. Our systems and processes are designed to protect your data at all stages, ensuring compliance with industry standards and regulations.
                          
                          </p>
                          <p>
                          <strong>Analyze the Data : </strong>
                          Collect, transcribe, and analyze recorded data, identifying essential insights for interpretation.
                          
                          </p>
                        </div>
                      </div>
                    </div>

                    <button onClick={handletoggle} className="btn btn-white">
                      {" "}
                      Read More
                    </button>
                  </div>
                </Col>
              </Row>
            </div>
          </div>
        </div>
      </section>
      <section className="py-50">
        <div className="container-wrapper how-works ">
          <div className="img-wrapper">
            <img src="images/services/Advantages-programming.jpg" alt="" />
          </div>
          <div className="text-wrapper">
            <div className="container">
              <Row align="middle">
                <Col md={12}>
                  <div className="content-wrapper">
                    <h2> Advantages to choose Poll Sphere?</h2>
                  
                    <p>
                      {" "}
                      <strong>Expertise : </strong>
                      Our team comprises skilled data scientists, analysts, and programmers with extensive experience in market research and data processing.
                    </p>
                    <div
                      className={
                        toggle1
                          ? "hide-content-wrapper show"
                          : "hide-content-wrapper "
                      }
                    >
                      <div className="container ">
                        <div className="hide-text">
                          <span onClick={cancletoggle} className="cancle-btn">
                            <FaTimes />{" "}
                          </span>

                          <h2> Advantages to choose Poll Sphere?</h2>
                  
                          <p>
                            {" "}
                            <strong>Expertise : </strong>
                            Our team comprises skilled data scientists, analysts, and programmers with extensive experience in market research and data processing.
                          </p>

                          <p>
                            {" "}
                            <strong>Tailored Solutions : </strong>
                            We understand that every project is unique. Our services are customized to meet your specific needs, ensuring that you get the most value out of your data.
                          </p>
                          <p>
                            {" "}
                            <strong>Efficiency : </strong>
                            We work diligently to deliver results promptly, allowing you to make decisions faster and stay ahead of the competition.
                          </p>


                          <h3>Limitations of IDIs</h3>
                          <p>
                            {" "}
                            <strong>Cost-Effective : </strong>
                            Our services offer a cost-effective solution to your data-related needs, eliminating the need for extensive in-house resources and infrastructure.
                          </p>
                          <p>
                            {" "}
                            <strong>Continuous Support : </strong>
                            Our commitment doesn't end with the project. We provide ongoing support to ensure that your data processes remain efficient and effective.
                          </p>

                          
                        </div>
                      </div>
                    </div>
                    <button onClick={handletoggle1} className="btn btn-white">
                      {" "}
                      Read More
                    </button>
                  </div>
                </Col>
              </Row>
            </div>
          </div>
        </div>
      </section>
    </div>
  );
}

export default Programming